import { Controller } from "@hotwired/stimulus"

// Either/or pairing of the user-group select and the field-user multi-select on
// the Scheduling Utilization widget config. Picking a group clears + disables
// the multi-select; picking users clears the group select.
export default class extends Controller {
  static targets = ["group", "users", "usersWrapper"]

  connect() {
    this.applyState()
  }

  onGroupChange() {
    if (this.hasGroup()) {
      this.clearUsers()
    }
    this.applyState()
  }

  onUsersChange() {
    if (this.hasUserSelection()) {
      this.groupTarget.value = ""
    }
    this.applyState()
  }

  applyState() {
    const groupActive = this.hasGroup()
    if (this.hasUsersTarget) {
      this.usersTarget.disabled = groupActive
      this.usersWrapperTarget.classList.toggle("opacity-50", groupActive)
    }
  }

  hasGroup() {
    return this.hasGroupTarget && !!this.groupTarget.value
  }

  hasUserSelection() {
    if (!this.hasUsersTarget) return false
    return Array.from(this.usersTarget.selectedOptions).some(o => o.value)
  }

  clearUsers() {
    if (!this.hasUsersTarget) return
    Array.from(this.usersTarget.options).forEach(o => { o.selected = false })
  }
}
